module.exports = __webpack_public_path__ + "img/a2877b3.jpg";